// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialFeesSetupState,
    FeesSetupSchema,
    FeesSetupFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const FeesSetup = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [fees_setup, setFeesSetup] = useState(InitialFeesSetupState);
    const [formFields, setFormFields] = useState(FeesSetupFormFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "multiselect")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getSchoolsByCompanies = async () => {
        spinService.on();
        const response = await get(EntityConstants.SCHOOLSBYCOMPANIES);
        const data = await response.json();
        attachOptions("schools", data);
        spinService.off();
    };

    const getFeesSetup = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.FEES_SETUPS + `/${id}`);
        const data = await response.json();
        setFeesSetup(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewFeesSetup = values.id === undefined;
        const url = isNewFeesSetup ? EntityConstants.FEES_SETUPS : EntityConstants.FEES_SETUPS + `/${values.id}`;
        const method = isNewFeesSetup ? post : put;
        const response = await method(url, { fees_setup: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewFeesSetup ? MessageContants.FEES_SETUP_CREATED : MessageContants.FEES_SETUP_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        getSchoolsByCompanies();
        if (id !== undefined) {
            getFeesSetup(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={fees_setup}
            validationSchema={FeesSetupSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {formFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.FEES_SETUP_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.FEES_SETUP_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

FeesSetup.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default FeesSetup;
